import PropTypes from 'prop-types';
import React from 'react';

import placeholder from '../../../img/placeholder.jpg';

const propTypes = {
    image: PropTypes.string,
    className: PropTypes.string,
};

const Projectron = ({ image = placeholder, className = null }) => (
    <svg
        viewBox="0 0 361.59 243"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <g id="Calque_1-2" data-name="Calque 1">
            <path
                fill="url(#Gradient)"
                d="M340.59.18c-4.74-.58-9.23.23-13.16,2.07L9.03,122.65c-5.29,2.1-9.03,7.25-9.03,13.28v92.77c0,7.9,6.4,14.3,14.3,14.3h216.85c5.45,0,10.18-3.05,12.6-7.53l114.71-199.59c2.49-4.36,3.65-9.57,2.93-15.1-1.41-10.72-10.06-19.28-20.79-20.59Z"
            />
            <rect
                fill="url('#img1')"
                x=".03"
                y="121.54"
                width="245.44"
                height="121.43"
                rx="14.3"
                ry="14.3"
            />
        </g>
        <pattern id="img1" patternUnits="userSpaceOnUse" width="1365" height="678">
            <image href={image} x="0" y="0" width="1365" height="678" />
        </pattern>
        <defs>
            <radialGradient id="Gradient" cx="0.5" cy="0.5" r="0.5" fx="0.25" fy="0.25">
                <stop offset="0%" stopColor="#EBE3C9" />
                <stop offset="100%" stopColor="#0F8AFF" />
            </radialGradient>
        </defs>
    </svg>
);

Projectron.propTypes = propTypes;

export default Projectron;
